import { BASE_URL } from "../config";
import { getSessionId } from "./SessionHandler";
import { handleResponse } from "../apis/responseHandler";

const MAX_FILES_PER_UPLOAD = 10;
const MAX_FILE_SIZE_BYTES = 25 * 1024 * 1024;

const validateFiles = (files) => {
  if (!files.length) {
    throw new Error("Select at least one file to upload");
  }

  if (files.length > MAX_FILES_PER_UPLOAD) {
    throw new Error(`You can upload up to ${MAX_FILES_PER_UPLOAD} files at once`);
  }

  const oversizedFile = files.find((file) => file.size > MAX_FILE_SIZE_BYTES);
  if (oversizedFile) {
    throw new Error(`${oversizedFile.name} is larger than 25 MB`);
  }
};

/**
 * Upload one or more files. The legacy (file, purpose) signature remains
 * supported for profile and master-data uploads.
 */
export async function uploadFile(fileOrFiles, purpose, options = {}) {
  const files = Array.from(
    typeof FileList !== "undefined" && fileOrFiles instanceof FileList
      ? fileOrFiles
      : [fileOrFiles],
  ).filter(Boolean);

  validateFiles(files);

  const formData = new FormData();
  const useAttachmentFields = Boolean(options.tranCode || options.fieldName);

  files.forEach((file) => {
    formData.append(useAttachmentFields ? "files" : "file", file);
  });

  if (purpose) {
    formData.append("purpose", purpose);
  }
  if (options.tranCode) {
    formData.append("tran_code", String(options.tranCode).trim().toLowerCase());
  }
  if (options.scope) {
    formData.append("scope", options.scope);
  }
  if (options.fieldName) {
    formData.append("field_name", options.fieldName);
  }
  if (options.parentId != null) {
    formData.append("parent_id", options.parentId);
  }

  const response = await fetch(`${BASE_URL}/api/v1/organisation/file_upload`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${getSessionId()}`,
    },
    body: formData,
  });

  return handleResponse(response);
}
